import { render, staticRenderFns } from "./InvestorOnboardingLayout.vue?vue&type=template&id=93df9316&"
import script from "./InvestorOnboardingLayout.vue?vue&type=script&lang=js&"
export * from "./InvestorOnboardingLayout.vue?vue&type=script&lang=js&"
import style0 from "./InvestorOnboardingLayout.vue?vue&type=style&index=0&id=93df9316&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports